module.exports = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: [
    'allow',
    'audioid',
    'target',
    'frameborder', 
    'allowfullscreen',
    'mozallowfullscreen',
    'webkitallowfullscreen', 
    'scrolling',
    'marginwidth',
    'marginheight'
  ]
};
